import { Divider } from 'antd';
import React, { FC, memo, useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useGetPaginatedHistoryQuery } from 'entities/History';
import { HistoryModal } from './HistoryModal';
import { HistoryActionRow } from 'widgets/HistoryActionRow';

interface LatestActivityProps {
  email: string;
  loggedUserEmail: string | undefined;
}

export const LatestActivity: FC<LatestActivityProps> = memo((props) => {
  const { email, loggedUserEmail } = props;

  const { t } = useAppTranslation(['profile', 'common']);

  const [openedHistoryModal, setOpenedHistoryModal] = useState(false);

  const { data } = useGetPaginatedHistoryQuery({ userName: email, limit: 5 }, { skip: !email });

  const hasRecords = (data?.content.length ?? 0) > 0;

  const openHistoryModal = useCallback(() => {
    setOpenedHistoryModal(true);
  }, []);

  const closeHistoryModal = useCallback(() => {
    setOpenedHistoryModal(false);
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div className="text-2xl font-semibold font-tektur">{t('Latest Activity')}</div>
        {hasRecords && (
          <div className="text-accent cursor-pointer underline text-sm" onClick={openHistoryModal}>
            {t('Show all')}
          </div>
        )}
      </div>
      <div className="flex flex-col">
        {hasRecords ? (
          data?.content.map((action, index, array) => (
            <div key={action.actionId}>
              <HistoryActionRow data={action} loggedUserEmail={loggedUserEmail} />
              {index < array.length - 1 ? <Divider className="border-accent ml-[20px]" type="vertical" /> : null}
            </div>
          ))
        ) : (
          <div className="text-xl text-primaryLight">{t('No data', { ns: 'common' })}</div>
        )}
      </div>
      <HistoryModal email={email} loggedUserEmail={loggedUserEmail} isOpened={openedHistoryModal} onCLose={closeHistoryModal} />
    </div>
  );
});
